//export const HTTPURL = "http://localhost:4040/";
export const HTTPURL = "https://demo-backend.kindlebit.com/";
//export const HTTPURL = "http://13.200.114.252:4040/";
export const StripePublicKey = "pk_test_51Qoex5Rx5fB3S6g6Aq6caXBELuFFGRKUWjdQxvgYVdpRA0bN7yjQQAdl9NcGlUP06rUwB9Y8pT1tWXAa5q8f2RtR00a4YrOpd1";